import PropTypes from "prop-types";
import ContentList from "../../../ContentList/component";
import Title from "../../../Title/component";
import TopStoriesPolicy from "../../../ContentArea/library/TopStoriesPolicy";
import HighDensityPolicy from "../../../ContentArea/library/HighDensityPolicy";
import DefaultPolicy from "../../../ContentArea/library/DefaultPolicy";
import { PRIMARY_COUNT } from "./constants";
import { FEATURED_DENSE_COUNT } from "../../../ContentArea/constants";

/**
 * The FeaturedNews component.
 *
 * This is the Featured area for News landing pages
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the FeaturedNews component
 */
export default function FeaturedNews({
    items,
    baseSection = "news",
    subSection = "",
    viewport = "viewportLarge",
    cardClickHandler = () => {},
    mobileAd,
    contentPackage,
    title = "Featured Content",
    displayPolicy,
}) {
    if (!items) {
        return null;
    }

    const isMobile = viewport === "viewportSmall";

    // There are two columns in the Featured News, below the content package (if present)
    const leftColItems = items.slice(0, PRIMARY_COUNT);
    const rightColItems = items.slice(PRIMARY_COUNT, FEATURED_DENSE_COUNT);

    const secondaryStoriesPolicy = isMobile
        ? new DefaultPolicy()
        : new HighDensityPolicy();

    const listProps = {
        baseSection: baseSection,
        subSection: subSection,
        loadMore: false,
        cardClickHandler: cardClickHandler,
    };

    return (
        <>
            <Title level="h2" hidden={true}>
                {title}
            </Title>
            <div
                className="featuredNews sclt-featuredTopStoriesDense"
                data-testid="featured-news"
            >
                <div className="featuredNewsContentPackage">
                    {contentPackage}
                </div>
                <div className="featuredTopStories">
                    <div
                        className="primaryTopStories"
                        data-cy="topStoriesFeaturedNews"
                    >
                        <ContentList
                            items={leftColItems}
                            displayPolicy={
                                new TopStoriesPolicy({
                                    contentPackage,
                                    displayPolicy,
                                    viewport,
                                })
                            }
                            trackingSection="featuredNewsPrimaryTopStoriesContentList"
                            {...listProps}
                        />
                    </div>
                    {mobileAd}
                    <div className="secondaryTopStories">
                        <ContentList
                            items={rightColItems}
                            displayPolicy={secondaryStoriesPolicy}
                            trackingSection="featuredNewsSecondaryTopStoriesContentList"
                            {...listProps}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

FeaturedNews.propTypes = {
    items: PropTypes.array.isRequired,
    baseSection: PropTypes.string,
    subSection: PropTypes.string,
    viewport: PropTypes.string,
    cardClickHandler: PropTypes.func,
    mobileAd: PropTypes.object,
    contentPackage: PropTypes.object,
    title: PropTypes.string,
    displayPolicy: PropTypes.object,
};
